/**
 * Generated by orval
 * Do not edit manually
 * WorkflowXMApi, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */

export type FormItemType = (typeof FormItemType)[keyof typeof FormItemType];

export const FormItemType = {
  TextInput: 0,
  TextArea: 1,
  NumberInput: 2,
  DatePicker: 3,
  DateTimePicker: 4,
  Checkbox: 5,
  Radio: 6,
  Select: 7,
  MultiSelect: 8,
  FileUpload: 9,
  Section: 10,
  CheckboxGroup: 11,
  Instructions: 12,
  SubItemCollection: 13,
} as const;
